<div class="main-container" *ngIf="!isLoading" data-cy="ar-payment-plan-list">

  <button mat-button class="cancel-button" (click)="close(false)" data-cy="ar-payment-plan-list-close-btn"><i class="material-icons">close</i></button>

  <div class="header" data-cy="ar-payment-plan-list-header">
    Payment Plans
  </div>

  <div class="payment-list-container" data-cy="ar-payment-plan-list-plans-container">

    <table mat-table [dataSource]="paymentPlans" class="payment-table mat-elevation-z8" data-cy="ar-payment-plan-list-plans-table">

      <ng-container matColumnDef="created">
        <th mat-header-cell *matHeaderCellDef data-cy="ar-payment-plan-list-created-header"> Created </th>
        <td mat-cell *matCellDef="let element" data-cy="ar-payment-plan-list-created-cell"> {{element.xauditCreatedOn | date }} </td>
      </ng-container>

      <ng-container matColumnDef="description">
        <th mat-header-cell *matHeaderCellDef data-cy="ar-payment-plan-list-description-header"> Description </th>
        <td mat-cell *matCellDef="let element" data-cy="ar-payment-plan-list-description-cell"> {{element.Description}} </td>
      </ng-container>

      <ng-container matColumnDef="amount">
        <th mat-header-cell *matHeaderCellDef data-cy="ar-payment-plan-list-amount-header"> Amount </th>
        <td mat-cell *matCellDef="let element" data-cy="ar-payment-plan-list-amount-cell"> {{ element.TotalAmount | currency }} </td>
      </ng-container>

      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef data-cy="ar-payment-plan-list-status-header"> Status </th>
        <td mat-cell *matCellDef="let element" data-cy="ar-payment-plan-list-status-cell"> {{ getPlanStatus(element) }} </td>
      </ng-container>

      <ng-container matColumnDef="paymentsLeft">
        <th mat-header-cell *matHeaderCellDef data-cy="ar-payment-plan-list-payments-left-header"> Payments Left </th>
        <td mat-cell *matCellDef="let element" data-cy="ar-payment-plan-list-payments-left-cell"> {{ getPaymentsLeftCount(element) }} </td>
      </ng-container>

      <ng-container matColumnDef="view">
        <th mat-header-cell *matHeaderCellDef data-cy="ar-payment-plan-list-view-header"> View </th>
        <td mat-cell *matCellDef="let element" data-cy="ar-payment-plan-list-view-cell">
          <button mat-button color="primary" (click)="openPlanCreationWindow('edit', element.PaymentPlanID)" data-cy="ar-payment-plan-list-view-btn">View</button>
        </td>
      </ng-container>

      <ng-container matColumnDef="select">
        <th mat-header-cell *matHeaderCellDef data-cy="ar-payment-plan-list-select-header"> Select </th>
        <td mat-cell *matCellDef="let element" data-cy="ar-payment-plan-list-select-cell">
          <mat-checkbox [(ngModel)]="element.DATA_SELECTED" data-cy="ar-payment-plan-list-select-checkbox"></mat-checkbox>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="paymentPlanColumns" data-cy="ar-payment-plan-list-header-row"></tr>
      <tr mat-row *matRowDef="let row; columns: paymentPlanColumns;" data-cy="ar-payment-plan-list-data-row"></tr>
    </table>

  </div>

  <mat-divider data-cy="ar-payment-plan-list-divider"></mat-divider>

  <div class="header" data-cy="ar-payment-plan-list-ledger-header">
    Ledger Items
  </div>

  <div class="ledger-list-container" data-cy="ar-payment-plan-list-ledger-container">

    <table mat-table [dataSource]="ledgerItems" class="payment-table mat-elevation-z8" data-cy="ar-payment-plan-list-ledger-table">

      <ng-container matColumnDef="postDate">
        <th mat-header-cell *matHeaderCellDef data-cy="ar-payment-plan-list-post-date-header"> Post Date </th>
        <td mat-cell *matCellDef="let element" data-cy="ar-payment-plan-list-post-date-cell">
          {{ convertUTCDateToLocalDateFromString(element.PostDate) | date }}
        </td>
      </ng-container>

      <ng-container matColumnDef="description">
        <th mat-header-cell *matHeaderCellDef data-cy="ar-payment-plan-list-ledger-description-header"> Description </th>
        <td mat-cell *matCellDef="let element" data-cy="ar-payment-plan-list-ledger-description-cell">
          {{ element.dataARTransactionItem.dataPatientCaseWorkItem.cfgCaseProcedure.ProcedureName }}
        </td>
      </ng-container>

      <ng-container matColumnDef="code">
        <th mat-header-cell *matHeaderCellDef data-cy="ar-payment-plan-list-code-header"> Code </th>
        <td mat-cell *matCellDef="let element" data-cy="ar-payment-plan-list-code-cell"> {{element.dataARTransactionItem.Code}} </td>
      </ng-container>

      <ng-container matColumnDef="amount">
        <th mat-header-cell *matHeaderCellDef data-cy="ar-payment-plan-list-ledger-amount-header"> Amount </th>
        <td mat-cell *matCellDef="let element" data-cy="ar-payment-plan-list-ledger-amount-cell">
          {{ calcAdjustedPrice(element) | currency }}
        </td>
      </ng-container>

      <ng-container matColumnDef="inPlan">
        <th mat-header-cell *matHeaderCellDef data-cy="ar-payment-plan-list-in-plan-header"> In Plan </th>
        <td mat-cell *matCellDef="let element" data-cy="ar-payment-plan-list-in-plan-cell">
          {{ element.DATA_IS_IN_PLAN ? 'Yes' : 'No' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="select">
        <th mat-header-cell *matHeaderCellDef data-cy="ar-payment-plan-list-ledger-select-header"> Select </th>
        <td mat-cell *matCellDef="let element" data-cy="ar-payment-plan-list-ledger-select-cell">
          <mat-checkbox *ngIf="checkIfCanSelectItem(element)"
                        [(ngModel)]="element.DATA_SELECTED"
                        data-cy="ar-payment-plan-list-ledger-select-checkbox"></mat-checkbox>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="ledgerItemColumns" data-cy="ar-payment-plan-list-ledger-header-row"></tr>
      <tr mat-row *matRowDef="let row; columns: ledgerItemColumns;" data-cy="ar-payment-plan-list-ledger-data-row"></tr>
    </table>

  </div>

  <div class="action-container" data-cy="ar-payment-plan-list-action-container">

    <button mat-raised-button
            color="primary"
            class="action-button"
            [disabled]="!checkForSelectedItem() || checkIfSelectedIsInPlan()"
            (click)="openPlanCreationWindow()"
            data-cy="ar-payment-plan-list-create-plan-btn">
      Create a plan
    </button>

    <button mat-raised-button
            color="primary"
            class="action-button"
            (click)="initMergePlan()"
            [disabled]="!checkIfCanMergePlan()"
            data-cy="ar-payment-plan-list-merge-plan-btn">
      Mege with a plan
    </button>

    <button mat-raised-button
            color="primary"
            class="action-button button-right"
            (click)="close(false)"
            data-cy="ar-payment-plan-list-done-btn">
      Done
    </button>

  </div>
</div>
<div class="spinner-container" *ngIf="isLoading" data-cy="ar-payment-plan-list-spinner-container">
  <mat-spinner data-cy="ar-payment-plan-list-spinner"></mat-spinner>
</div>
